import type { FormTourConfig } from './formTour';

const ADD_SENDER_ACCOUNT_START_PATH = '/settings/sender-accounts';
const SETTINGS_PATH_PREFIX = '/settings';
const SENDER_ACCOUNT_ROW_TEST_ID = '@sender-accounts-row';

export const addSenderAccountTour = {
  taskId: 'add_sender_account',
  storageKey: 'onboarding-add-sender-account-tour-step',
  startPath: ADD_SENDER_ACCOUNT_START_PATH,
  activePathPrefix: SETTINGS_PATH_PREFIX,
  navStepCount: 1,
  overlineLabel: 'Add Sender Account Tour',
  steps: [
    {
      title: 'Open Settings',
      description:
        'Click Settings in the sidebar, then open Sender Accounts under Outreach to manage email senders.',
      targetTestIds: ['@sidebar-settings'],
    },
    {
      title: 'Open Sender Accounts',
      description: 'In the settings sidebar, choose Sender Accounts.',
      targetTestIds: ['@settings-sender-accounts'],
      disableBack: true,
    },
    {
      title: 'Add Sender Account',
      description: 'Click Add Sender Account to connect an email address you will send from.',
      targetTestIds: ['@sender-accounts-add'],
      closeTargetTestIdsOnBack: ['@sender-account-ses-modal', '@sender-account-add-modal'],
    },
    {
      title: 'Choose your email provider',
      description: 'Connect Google or Microsoft. You will return here when done.',
      targetTestIds: ['@sender-account-provider-options'],
      highlightTargetTestIds: ['@sender-account-provider-options'],
      highlightExpandModal: true,
      contextTargetTestIds: ['@sender-account-add-modal'],
      closeTargetTestIdsOnBack: ['@sender-account-ses-modal', '@sender-account-add-modal'],
    },
    {
      title: 'Enter your email details',
      description:
        'In the "Add Sender Account to Harbor directly" form, enter your email address. You can fill in your name and signature next.',
      targetTestIds: ['@sender-account-ses-email'],
      panelPlacement: 'above',
      closeTargetTestIdsOnBack: ['@sender-account-ses-modal'],
    },
    {
      title: 'Click Add',
      description:
        'Click Add to save your Harbor Sender Account. The tour completes when the new account appears in the Sender Accounts table.',
      targetTestIds: ['@sender-account-ses-submit'],
      panelPlacement: 'above',
    },
  ],
  stepActions: {
    0: {
      type: 'wait-for-target',
      advanceTo: 1,
      waitForTargetTestIds: ['@settings-sender-accounts'],
    },
    1: {
      type: 'wait-for-target',
      advanceTo: 2,
      waitForTargetTestIds: ['@sender-accounts-add'],
    },
    2: {
      type: 'wait-for-target',
      advanceTo: 3,
      waitForTargetTestIds: ['@sender-account-add-modal'],
      captureRowCountBaselineTestIds: [SENDER_ACCOUNT_ROW_TEST_ID],
    },
    3: {
      type: 'wait-for-target-or-complete',
      advanceTo: 4,
      waitForTargetTestIds: ['@sender-account-ses-modal'],
      completeWhenTargetTestIds: [SENDER_ACCOUNT_ROW_TEST_ID],
      completeWhenCountIncreases: true,
    },
    4: { type: 'next' },
    5: {
      type: 'complete-when-target',
      waitForTargetTestIds: [SENDER_ACCOUNT_ROW_TEST_ID],
      completeWhenCountIncreases: true,
    },
  },
} as const satisfies FormTourConfig;
